export const SOURCE_CODE = 'source';
export const CM_TESTING = 'cmtest';
